class RangeSlider extends HTMLElement {
  static get observedAttributes() {
    return ['value', 'step', 'min', 'max']
  }

  constructor() {
    super()

    this.value = parseFloat(this.getAttribute('value')) || 0
    this.step = parseFloat(this.getAttribute('step')) || 1
    this.min = parseFloat(this.getAttribute('min')) || 0
    this.max = parseFloat(this.getAttribute('max')) || 100
    this.bind = this.getAttribute('bind')
    this.input = document.querySelector(this.bind) || undefined

    this.dragging = false

    this.track = document.createElement('div')
    this.track.classList.add('track')
    this.appendChild(this.track)

    this.overlay = document.createElement('div')
    this.overlay.classList.add('overlay')
    this.appendChild(this.overlay)

    this.slider = document.createElement('input')
    this.slider.type = 'range'
    this.slider.id = 'slider'
    this.slider.min = this.min
    this.slider.max = this.max
    this.slider.step = this.step
    this.slider.value = this.value
    this.appendChild(this.slider)
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'value':
        this.slider.value = newValue
        break
      case 'step':
        this.slider.step = newValue
        break
      case 'min':
        this.slider.min = newValue
        break
      case 'max':
        this.slider.max = newValue
        break
    }
    this.update()
  }

  connectedCallback() {
    this.slider.addEventListener(
      'input',
      function () {
        if (this.input) {
          this.input.value = this.slider.value
        }
        this.update()
      }.bind(this)
    )
    if (this.input) {
      if (this.input.value) {
        this.slider.value = parseFloat(this.input.value)
      }
      this.input.addEventListener(
        'input',
        function () {
          this.slider.value = parseFloat(this.input.value)
          this.update()
        }.bind(this)
      )
    }

    this.update()
  }

  update() {
    this.value = this.slider.value
    const valuePercentage =
      (this.slider.value - this.min) / (this.max - this.min)
    this.overlay.style.setProperty('--value', `${valuePercentage}`)
  }
}

customElements.define('range-input', RangeSlider)
